export enum RejectionErrorCode {
  InvalidType = 'INVALID_TYPE',
  ExceededMaxSize = 'EXCEEDED_MAX_SIZE',
  ExceededMaxFiles = 'EXCEEDED_MAX_FILES',
  Unknown = 'UNKNOWN',
}

export interface FileRejection {
  file: File;
  errorCodes: RejectionErrorCode[];
}

export interface FileRejections {
  partial: boolean;
  rejections: FileRejection[];
}

export function errorMessageFromCode(errorCode: RejectionErrorCode): string {
  switch (errorCode) {
    case RejectionErrorCode.InvalidType:
      return 'One or more files are not the correct type.';
    case RejectionErrorCode.ExceededMaxSize:
      return 'One or more files are too large.';
    case RejectionErrorCode.ExceededMaxFiles:
      return 'Maximum number of files has been exceeded.';
    case RejectionErrorCode.Unknown:
      return 'Unknown Error';
  }
}
